import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

interface GlobalYesNoDialogState {
  show: boolean,
  invert: boolean,
  focusindex: number,
  addor: boolean,
  resolve: ((value: boolean | PromiseLike<boolean>) => void) | null,
  content: React.ReactNode | null,
  type:'info'|'warning',
  inform: string,
  warning: string,
};

interface GlobalYesNoDialogData {
  resolve: ((value: boolean | PromiseLike<boolean>) => void) | null,
  content: React.ReactNode | null,
  invert: boolean,
  addor: boolean,
  focusindex: number,
  inform?: string,
  warning?: string,
  type:'info'|'warning',
};

const initialState: GlobalYesNoDialogState = {
  show: false,
  invert: false,
  focusindex: 0,
  addor: false,
  resolve: null,
  content: null,
  type: 'info',
  inform:'',
  warning:'',
};

/**
 * Slice for controlling Global Yes No Dialog
 */
const globalYesNoDialogSlice = createSlice({
  name: 'globalYesNoDialog',
  initialState,
  reducers: {
    showGlobalYesNoDialog: (state, action: PayloadAction<GlobalYesNoDialogData>) => {
      state.show = true;
      state.invert = action.payload.invert;
      state.addor = action.payload.addor;
      state.focusindex = action.payload.focusindex;
      state.resolve = action.payload.resolve;
      state.content = action.payload.content;
      state.type = action.payload.type ?? 'info';

      state.inform = action.payload.type === 'info' ? '' : 'none';
      state.warning = action.payload.type === 'warning'? '' : 'none';
    },
    hideGlobalYesNoDialog: (state) => {
      state.show = false;
      state.resolve = null;
      state.content = null;
    },
  }
});

export default globalYesNoDialogSlice.reducer;

export const { showGlobalYesNoDialog, hideGlobalYesNoDialog } = globalYesNoDialogSlice.actions;
